module.exports = __webpack_public_path__ + "static/media/mensajeria_unificada_icon.d38a8ced.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/mensajeria_unificada_icon.svg
// module id = 1871
// module chunks = 0